import { yup } from '@guiker/yup-util'

export const listingUnitIdNested = yup.object({
  listingId: yup.string().required(),
  unitId: yup.string().required(),
})

export type ListingUnitIdNested = yup.InferType<typeof listingUnitIdNested>
